<template>
  <div class="main-container notice_wrap">
    <div class="notice">
      <div class="title">通知公告：</div>
      <div class="content">
        <el-carousel trigger="click" height="380px" :interval="5000">
          <el-carousel-item v-for="(item,index) in list" :key="index">
            <div class="notice-info">
              <span class="date">[2016-12-11]</span>{{item.title}}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--<div class="more">更多+</div>-->
    </div>
  </div>
</template>
<script>
  import {notifications} from 'src/api/notificationApi'

  export default {
    components: {},
    data () {
      return {
        list: []
      }
    },
    mounted () {
      this.$nextTick(function () {
        this.onLoadNotices()
      })
    },
    methods: {
      onLoadNotices () {
        notifications().then((resp) => {
          let list = []
          for (let i = 0; i < resp.length; i++) {
            let oa = resp[i]
            list.push({
              id: oa.id,
              title: oa.title
            })
          }
          this.list = list
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/home/component/HomeNotice.vue